<template>
    <basic-content-layout class="not-found">
        <error404></error404>
    </basic-content-layout>
</template>
<script>
    import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
    import Error404 from "../../components/organisms/Error404.vue"
    export default {
        components: {
            BasicContentLayout,
            Error404
        }
    }
</script>